import * as React from "react";
import { Content, PageHeader, Stage } from "../layout";

export const Debug: React.FunctionComponent = () => {
    return (
        <Stage>
            <PageHeader title="Debug" />
            <Content></Content>
        </Stage>
    );
};
